import 'constants/constants.json';

import template from './googleMap.html';
import './googleMap.scss';

export const GoogleMap = angular
    .module('checkout.components.googleMap', [
        'app.constants'
    ]).component('googleMap', {
        template,
        bindings: {
            address: '<'
        },
        controller: class GoogleMapCtrl {
            constructor(GOOGLE_STATIC_MAPS_KEY) {
                this.GOOGLE_STATIC_MAPS_KEY = GOOGLE_STATIC_MAPS_KEY;
            }

            $onInit() {
                const formattedAddress = `${this.address.address1} ${this.address.address2 ? this.address.address2 : ''}, ${this.address.city}, ${this.address.state}, ${this.address.postalCode}`; // eslint-disable-line max-len
                const encodedAddress = encodeURIComponent(formattedAddress);
                this.mapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${encodedAddress}&scale=2&zoom=14&size=600x125&maptype=roadmap&markers=${encodedAddress}&key=${this.GOOGLE_STATIC_MAPS_KEY}`; // eslint-disable-line max-len
                this.mapLinkUrl = `https://google.com/maps/place/${formattedAddress}`;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/googleMap/googleMap.js